import { AddressLookup } from "@/components/inputs/AddressLookup";
import { HubFormItem } from "@/components/inputs/HubFormItem";
import { invalidLatLng } from "@/lib/crg_apis/types/latlng";
import { Alert, Button, Col, Input, Row, Typography } from "antd";
import { LatLngLiteral } from "leaflet";
import { MutableRefObject, useState } from "react";
const {
  TextArea
} = Input;
const {
  Title
} = Typography;
interface PolygonStageSidebarProps {
  isAreaValid: boolean;
  onContinue: () => void;
  /* Until this tool supports multiple polygons, we can just include here. */
  polygonName: string;
  setFocusPoint: (latLng: LatLngLiteral) => void;
  setPolygonName: (name: string) => void;
  refs?: {
    addressLookup?: MutableRefObject<null>;
    polygonNameInput?: MutableRefObject<null>;
    generateGridBtn?: MutableRefObject<null>;
  };
}
export const PolygonStageSidebar = ({
  isAreaValid,
  onContinue,
  polygonName,
  setFocusPoint,
  setPolygonName,
  refs
}: PolygonStageSidebarProps) => {
  const [address, setAddress] = useState("");
  return <Row gutter={[16, 16]} data-sentry-element="Row" data-sentry-component="PolygonStageSidebar" data-sentry-source-file="PolygonStageSidebar.tsx">
      <Col span={24} data-sentry-element="Col" data-sentry-source-file="PolygonStageSidebar.tsx">
        <div ref={refs?.addressLookup}>
        <Title level={5} data-sentry-element="Title" data-sentry-source-file="PolygonStageSidebar.tsx">Search location of Large Site on map</Title>
        <AddressLookup address={address} onChange={(address, latLng) => {
          setAddress(address);
          setFocusPoint(latLng);
        }} onClear={() => {
          setAddress("");
          setFocusPoint(invalidLatLng);
        }} placeholder="" data-sentry-element="AddressLookup" data-sentry-source-file="PolygonStageSidebar.tsx">
          <TextArea rows={2} placeholder="Enter address" data-sentry-element="TextArea" data-sentry-source-file="PolygonStageSidebar.tsx" />
        </AddressLookup>
        </div>
      </Col>
      <Col span={24} data-sentry-element="Col" data-sentry-source-file="PolygonStageSidebar.tsx">Use the map and drawing tools to the left to define the boundary of your large site.</Col>
      <Col span={24} data-sentry-element="Col" data-sentry-source-file="PolygonStageSidebar.tsx">
        <Alert type="warning" message=<>
            Tip: Avoid including bodies of water in your large site polygon. The presence of water will automatically
            return flood risk and skew results.
          </> data-sentry-element="Alert" data-sentry-source-file="PolygonStageSidebar.tsx" />
      </Col>
      {isAreaValid && <Col span={24}>
          <div ref={refs?.polygonNameInput}>
          <HubFormItem hasFeedback validateStatus={polygonName.trim() ? "success" : "error"} help={polygonName.trim() ? "Valid polygon name entered." : "A name must be provided for the polygon."} label="Polygon name" layout="vertical">
            <Input name="polygonName" onChange={event => setPolygonName(event.target.value)} placeholder="Enter name for the drawn polygon" value={polygonName} />
          </HubFormItem>
          </div>
        </Col>}
      <Col span={24} data-sentry-element="Col" data-sentry-source-file="PolygonStageSidebar.tsx">
        <div ref={refs?.generateGridBtn}>
        <Button block type="primary" disabled={!isAreaValid || !polygonName.trim()} onClick={onContinue} data-sentry-element="Button" data-sentry-source-file="PolygonStageSidebar.tsx">
          Generate Grid Points
        </Button>
        </div>
      </Col>
    </Row>;
};